function getEnvVariables() {
  if (typeof window !== 'undefined') {
    if (!window.envVariables) {
      throw new Error('window.envVariables is missing in browser environment');
    }
    return window.envVariables;
  }
  // Fallback to process.env for server-side
  return {
    versionNumber: process.env.VERSION_NUMBER,
    environment: process.env.APP_ENV,
    apmServerUrl: process.env.APM_SERVER_URL,
    apmSampleRate: process.env.APM_SAMPLE_RATE,
    areenaApiUrlOverride: process.env.AREENA_API_URL,
    appIdFrontend: process.env.APP_ID_FRONTEND,
    appKeyFrontend: process.env.APP_KEY_FRONTEND,
    brazeSdkApiKey: process.env.BRAZE_SDK_API_KEY,
  };
}

export const envVariables = getEnvVariables();

export function isTestEnvironment(): boolean {
  return envVariables.environment === 'test';
}
